import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const LegalGuaranteeOfConformityStatementPreview = styled.div`
  padding: ${Spacing.S12} ${Spacing.S16};
  background: ${Color.Orange50};
  font-style: italic;
  border-inline-start: ${Spacing.S2} solid ${Color.Yellow600};
`

export const LegalGuaranteeOfConformityCategoriesList = styled.ul`
  padding-left: ${Spacing.S20};
  list-style-type: disc;
  column-count: 2;
`
